import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectSuccessWebviewPaymentStatusModalViewState } from '../store/selectors';

export default () => {
  const { t } = useTranslation();

  const { isVisible: isOpenWebViewSuccessAlertModal, payment } = useSelector(
    selectSuccessWebviewPaymentStatusModalViewState
  );

  const onAcceptWebViewSuccessPaymentModal = () => {
    window.location.reload();
  };

  const getSuccessAlertModalTitle = serviceId => {
    switch (true) {
      case ['add_balance_custom', 'wallet'].includes(serviceId):
        return t('webview.alert_modal.wallet_and_balance_success_title');
      case ['bump', 'bump3', 'bump5', 'bump10'].includes(serviceId):
        return t('webview.alert_modal.bump_success_title');
      case ['featured1', 'featured5', 'featured15', 'featured30'].includes(
        serviceId
      ):
        return t('webview.alert_modal.featured_success_title');
      case [
        'ad',
        'five_ads',
        'five_paid_ads',
        'one_ad',
        'one_paid_ad',
        'twenty_ads',
        'twenty_paid_ads'
      ].includes(serviceId):
        return t('webview.alert_modal.ad_success_title');
      case ['pay_invoice'].includes(serviceId):
        return t('webview.alert_modal.pay_invoice_success_title');
      case ['pin_recovery'].includes(serviceId):
        return t('webview.alert_modal.pin_recovery_success_title');
      case ['vip1', 'vip5', 'vip15', 'vip30'].includes(serviceId):
        return t('webview.alert_modal.vip_success_title');
      default:
        return t('webview.alert_modal.payment_success_done_title');
    }
  };

  const getSuccessAlertModalMessage = serviceId => {
    switch (true) {
      case ['add_balance_custom', 'wallet'].includes(serviceId):
        return t('webview.alert_modal.wallet_and_balance_success_message');
      case ['bump', 'bump3', 'bump5', 'bump10'].includes(serviceId):
        return t('webview.alert_modal.bump_success_message');
      case ['featured1', 'featured5', 'featured15', 'featured30'].includes(
        serviceId
      ):
        return t('webview.alert_modal.featured_success_message');
      case [
        'ad',
        'five_ads',
        'five_paid_ads',
        'one_ad',
        'one_paid_ad',
        'twenty_ads',
        'twenty_paid_ads'
      ].includes(serviceId):
        return t('webview.alert_modal.ad_success_message');
      case ['pay_invoice'].includes(serviceId):
        return t('webview.alert_modal.pay_invoice_success_message');
      case ['vip1', 'vip5', 'vip15', 'vip30'].includes(serviceId):
        return t('webview.alert_modal.vip_success_message');
      default:
        return '';
    }
  };

  const successWebViewAlertModalTitle = getSuccessAlertModalTitle(
    payment?.service_id
  );
  const successWebViewAlertModalMessage = getSuccessAlertModalMessage(
    payment?.service_id
  );

  return {
    isOpenWebViewSuccessAlertModal,
    onAcceptWebViewSuccessPaymentModal,
    successWebViewAlertModalTitle,
    successWebViewAlertModalMessage,
    payment
  };
};
